import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { getCustomers } from '../../api';
import { CustomersHttpQuery } from '../../config';
import { CustomerViewModel, mapCustomersApiToViewModel } from '../../model';

export interface CustomersApiGetHookResult {
  customers: CustomerViewModel[];
  isFetching: boolean;
  isFetched: boolean;
}

export const useCustomersApiGet = (): CustomersApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetching, isFetched } = useQuery({
    queryKey: [CustomersHttpQuery['GetCustomers'].key],
    queryFn: async () => {
      const customers = await getCustomers(axios);
      return [...mapCustomersApiToViewModel(customers)];
    },
    enabled: true,
    structuralSharing: false,
    gcTime: Infinity,
    staleTime: 0,
  });

  return {
    isFetched,
    isFetching,
    customers: data || [],
  };
};